import React from 'react'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'

import { useOverviewTable } from './hooks'
import { getActions } from './helpers'
import { CandidateCell } from 'components/shared/Table/common/Cells/CandidateCell/CandidateCell'
import { PhoneCell } from 'components/shared/Table/common/Cells/PhoneCell/PhoneCell'
import { LanguageCell } from 'components/shared/Table/common/Cells/LanguageCell/LanguageCell'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { JobProgressCell } from 'components/shared/Table/common/Cells/JobProgressCell/JobProgressCell'

export const OverviewTable = ({
  search,
  handleCopy,
  handleDelete,
  handleEdit,
}) => {
  const { state, handlers } = useOverviewTable({ search })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, rowActions, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row type="head">
            {headers.map(
              ({ columnDef, getToggleSortingHandler, getIsSorted }) => {
                const { accessorKey, header, alignLeft } = columnDef

                return (
                  <HeaderCell
                    key={header}
                    alignLeft={!!alignLeft}
                    sortType={getIsSorted()}
                    text={header}
                    onClick={getToggleSortingHandler()}
                    hasSorting={accessorKey}
                  />
                )
              },
            )}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{
            title: t`No results yet`,
            text: t`Try adjusting your search`,
          }}
          isLoaded={!isFetching}
        >
          {model.rows.map(({ id, original }) => {
            if (!original?.timestamps?.created) {
              return null
            }

            const {
              email,
              language,
              name,
              phone,
              selection_stage,
              status,
              timestamps,
            } = original

            const actions = getActions(
              { actions: rowActions, jobSeeker: original },
              { handleCopy, handleDelete, handleEdit },
            ).filter(action => action.type !== 'ACTION_COPY')

            return (
              <Table.Row key={id} type="body">
                <CandidateCell email={email} name={name} indentIcon />
                <PhoneCell phone={phone} />
                <LanguageCell language={language} />
                <DateCell date={timestamps?.created} hasNowLabel />
                <JobProgressCell
                  progress={selection_stage - 1}
                  hasInterviewModule={false}
                  status={status}
                  type="candidate"
                />
                <ActionsCell>
                  <ActionsDropdown size="medium" {...{ actions }} />
                </ActionsCell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
